export default __webpack_public_path__ + "static/media/IMPRESION3D.cf615b52.webp";